import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface IPromotions {
    created_at?: string
    end_at: string
    id?: string
    language: string
    name: string
    priority: number
    start_at: string
    status: string
    updated_at?: string
    pc_url?: string
    mo_url?: string
}

export const getPromotions = async (
    active?: boolean,
    language?: 'ko' | 'en',
    current_page: number = 1,
): Promise<ApiRes<IPromotions[]>> => {
    // language 전달 시 request header 의 language 를 강제 (admin 언어 설정과 무관하게 조회)
    return await apiGet(
        API_URL,
        `admin/promotions?${active !== undefined ? `active=${active}` : 'active=false'}&current_page=${current_page}`,
        undefined,
        language ? {language} : undefined,
    )
}
